import React from 'react';
import '../Styles/YesNoDialog.scss';

const YesNoDialog = ({ isOpen, title, question, handleYesClick, handleClose }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div className="dialog-overlay" onClick={handleBackdropClick}>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2 className="dialog-title">{title}</h2>
          <button 
            className="dialog-close" 
            onClick={handleClose}
            aria-label="Fermer"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path 
                d="M15 5L5 15M5 5L15 15" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        
        <div className="dialog-content">
          <p className="dialog-question">{question}</p>
        </div>
        
        <div className="dialog-actions">
          <button 
            className="dialog-button dialog-button--secondary" 
            onClick={handleClose}
          >
            Non
          </button>
          <button 
            className="dialog-button dialog-button--primary" 
            onClick={handleYesClick}
          >
            Oui
          </button>
        </div>
      </div>
    </div>
  );
};

export default YesNoDialog;